import api from "./init";
import { headers } from "./apiHelper";

export const getExams = (type, resolveHandler, offset = 0, limit = 100000) => {
  api
    .get(`/exams/my`, {
      headers,
      params: {
        offset: `${offset}`,
        limit: `${limit}`,
        orderType: `DESC`,
        "filter[type]": `${type}`,
      },
    })
    .then((res) => {
      resolveHandler(res.data);
    });
};

export const getExam = (resolveHandler) => {
  api
    .post(
      "/exams",
      {
        type: "EXAM",
      },
      {
        headers,
      }
    )
    .then((res) => {
      resolveHandler(res.data);
    });
};

export const submitExam = (examID, examAnswers, examTime, resolveHandler) => {
  api
    .post(
      `/exams/${examID}`,
      {
        answers: examAnswers,
        time: examTime,
      },
      {
        headers,
      }
    )
    .then((res) => {
      resolveHandler(res.data);
    });
};
